import { ContentState, Editor, EditorState } from 'draft-js'
import * as React from 'react'
import enhanceWithClickOutside from 'react-click-outside'
import { MERGE_TAG_TRANSLATION } from '@disco/constants/content-editor'
import { keyEqualTo } from '@disco/utils/keyboard'
import HelpTooltip from 'components/common/tooltip'
import Input from 'components/ui/input'
import styles from './index.module.css'

type Props = {
  children: React.ReactNode
  setEditorState: (...args: Array<any>) => any
  getEditorState: (...args: Array<any>) => any
  fallback: string
  contentState: ContentState
  entityKey: number
  store: {
    getEditorRef: () => Editor
  }
}
type OwnState = {
  fallbackVisible: boolean
}

class RichEditorMergeTag extends React.Component<Props, OwnState> {
  state = {
    fallbackVisible: false,
  }
  setFallback = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    e.stopPropagation()
    const { value } = e.target
    const { contentState, entityKey, getEditorState, setEditorState } =
      this.props
    const newContentState = contentState.mergeEntityData(entityKey, {
      fallback: value,
    })
    const editorState = EditorState.push(
      getEditorState(),
      newContentState,
      'apply-entity',
    )
    setEditorState(editorState)
    return 'handled'
  }
  showFallback = () => {
    const editor = this.props.store.getEditorRef()
    editor.props.wrapperRef.setReadOnlyMode(true)
    this.setState({
      fallbackVisible: true,
    })
  }
  onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (keyEqualTo(e, 'Tab') || keyEqualTo(e, 'Enter')) {
      e.preventDefault()
      e.stopPropagation()
      this.hideFallback()
    }
  }
  hideFallback = () => {
    const editor = this.props.store.getEditorRef()
    editor.props.wrapperRef.setReadOnlyMode(false)
    this.setState({
      fallbackVisible: false,
    })
  }
  handleClickOutside = e => {
    const className = e?.currentTarget?.className || ''
    if (className.includes('rich-editor__merge-tag')) return
    this.hideFallback()
  }

  render() {
    const { entityKey, contentState, children } = this.props
    const { fallback, type } = contentState.getEntity(entityKey).getData()
    // you should ALWAYS pass children in decorators, otherwise you'll gonna
    // have a bad time:
    // https://github.com/facebook/draft-js/issues/1327
    // https://github.com/facebook/draft-js/issues/1200
    return (
      <span
        id={`merge-tag-${this.props.entityKey}`}
        className={styles.richEditorMergeTag}
        onClick={this.showFallback}
      >
        {children}
        {this.state.fallbackVisible && (
          <div className={styles.richEditorMergeTagFallbackPopup}>
            <div className={styles.richEditorMergeTagFallbackPopupTitle}>
              Default{' '}
              <HelpTooltip>
                Recipient&#39;s {MERGE_TAG_TRANSLATION[type].toLowerCase()} will
                be inserted here. If there&#39;s no{' '}
                {MERGE_TAG_TRANSLATION[type].toLowerCase()} to insert, the
                default text you add here will be used instead.
              </HelpTooltip>
            </div>
            <div className={styles.richEditorMergeTagFallbackPopupValue}>
              <Input
                className={styles.richEditorMergeTagFallbackPopupValueInput}
                autoFocus
                defaultValue={fallback}
                onChange={this.setFallback}
                onKeyDown={this.onKeyDown}
              />
            </div>
          </div>
        )}
      </span>
    )
  }
}

export default enhanceWithClickOutside(RichEditorMergeTag) as any
